<app-collapse [rounded]="true" [collapse]="readonly ? null : collapseBerthVisitDetails"
              [showOnLoad]="((!context.visit.terminalPlanningEnabled && !context.hasBeenDeclared()) || !berthVisit.berth || (context.visit.orderNauticalServices && berthVisit.ata && !berthVisit.atd && !berthVisit.nextMovement.order)) || (context.visitInTerminalPlanning() && !terminalVisit?.status?.acceptedByAgent)"
              [animateOnLoad]="true"
              [validationModel]="berthVisit" [renderWhenCollapsed]="true">
  <div class="d-flex justify-content-between">
    <!-- Berth summary -->
    @if (!context.berthVisitInTerminalPlanningMode(berthVisit)) {
      <div class="col-auto d-flex align-items-center p-3">
        <div class="align-bottom">
          @if (getBerthVisitInfo()?.harbourMasterInfo?.tidalWindowStatus; as status) {
            @if (status.tidalShip) {
              <span class="fa text-info fa-fw me-2"
                    [ngClass]="status.tidalWindowType === 'ASTRO' ? 'fa-satellite-dish' : 'fa-water'"
                    title="Tidal restricted"></span>
            }
          }
          <span
            class="fw-bold text-portbase-dark">{{ formatBerth(berthVisit) | titlecase }}{{ formatBerthCode(berthVisit.berth) }}</span>
          <span class="text-muted mx-3 d-none d-lg-inline">{{ getTimeAtBerth(berthVisit) }}</span>
        </div>
        @if (!readonly) {
          @if (berthVisit.bollardFrom && berthVisit.bollardTo) {
            <div class="d-none d-md-block">
              <div class="d-flex text-muted ms-2">
                <div class="align-self-start"><span
                  class="border rounded py-1 px-2"><small>{{ berthVisit.bollardFrom }}</small></span>
                </div>
                <div class="align-self-baseline" style="margin-top: 2px;"><i class="fa fa-fw fa-arrows-alt-h"></i>
                </div>
                <div class="align-self-start"><span
                  class="border rounded py-1 px-2"><small>{{ berthVisit.bollardTo }}</small></span>
                </div>
              </div>
            </div>
          }
          <ng-container *ngTemplateOutlet="loadDischargeTemplate"></ng-container>
          @if (berthVisit.mooring) {
            <div class="d-none d-md-block ms-2 text-muted">
              {{ mooringFormatter(berthVisit.mooring) }}
            </div>
          }
          <div class="ms-auto d-none d-md-block text-dark">
            <!-- Icons/actions for first berth only -->
            @if (firstBerth && !isNextBerthVisit) {
              <app-entry-dependency-icon></app-entry-dependency-icon>
            }
            <!-- Icons/actions for last berth only -->
            @if (lastBerth && !isNextBerthVisit) {
              <!-- Transfer to next agent icon-->
              @if (this.context.visit.nextOwner) {
                <span class="mx-2" [title]="this.context.visit.nextOwner.fullName"><span
                  class="fa fa-fw fa-people-arrows me-1"></span></span>
              }
              <!-- Storm pilotage icon-->
              @if (!isNextBerthVisit && context.isStormPilotageInfoRequiredForPortEntry(context.visit)) {
                <span class="mx-2"
                      [title]="'Storm pilotage information required'"><span
                  class="fa fa-fw fa-wind me-1"></span></span>
              }
            }
            <app-waste-at-berth-icon [berthVisit]="berthVisit"></app-waste-at-berth-icon>
          </div>
        }
      </div>
    } @else {
      <div class="col-auto d-flex align-items-center p-3">
        <span
          class="fw-bold text-portbase-dark">{{ formatBerth(berthVisit) | titlecase }}</span>
        <span class="d-none d-md-inline text-muted mx-3">{{ getTimeAtTerminal(berthVisit) }}</span>
        @if (!readonly) {
          <ng-container *ngTemplateOutlet="loadDischargeTemplate"></ng-container>
          @if (terminalVisit?.info) {
            @if (terminalVisit.info.bollardAft && terminalVisit.info.bollardFore) {
              <div class="d-none d-md-block">
                <div class="d-none d-md-flex text-muted ms-2">
                  <div class="align-self-start"><span
                    class="border rounded py-1 px-2"><small>{{ getTerminalVisitBollardFrom }}</small></span>
                  </div>
                  <div class="align-self-baseline" style="margin-top: 2px;"><i class="fa fa-fw fa-arrows-alt-h"></i>
                  </div>
                  <div class="align-self-start"><span
                    class="border rounded py-1 px-2"><small>{{ getTerminalVisitBollardTo }}</small></span>
                  </div>
                </div>
              </div>
            }
            @if (terminalVisit?.info?.mooringOrientation) {
              <div class="d-none d-md-block ms-2 text-muted">
                {{ terminalMooringFormatter(terminalVisit.info.mooringOrientation) }}
              </div>
            }
          }
        }
      </div>
    }
    <!-- Shore power and Terminal planning summary -->
    @if (!readonly) {
      <div class="col-auto align-self-center">
        @if (berthVisit.shorePower?.shorePowerEnabled) {
          <app-message-status [messageStatus]="getShorePowerStatus"
                              label="Shore power" [reason]="getShorePowerTooltipMessage">
          </app-message-status>
        }
        @if (showTerminalStatus) {
          <app-message-status [messageStatus]="getTerminalDeclarationStatus"
                              label="Terminal" [reason]="getTerminalVisitTooltipMessage"
                              [header]="terminalTooltipHeader"></app-message-status>
        }
      </div>
    }
  </div>
</app-collapse>
<ng-template #collapseBerthVisitDetails>
  <div class="collapse">
    <div class="p-3 border rounded-bottom mb-3">
      <app-berth-visit-details [berthVisit]="berthVisit" [firstBerth]="firstBerth" [lastBerth]="lastBerth"
                               [pilotOnBoard]="getPilotOnBoard" [isBerthOfTransfer]="isBerthOfTransfer"
                               [isNextBerthVisit]="isNextBerthVisit"></app-berth-visit-details>
    </div>
  </div>
</ng-template>

<ng-template #loadDischargeTemplate>
  @if (terminalVisit?.info?.expectedDischarge || berthVisit.discharge) {
    <span class="d-none d-md-inline text-muted mx-3"
          title="Discharging {{terminalVisit?.info?.expectedDischarge ?? berthVisit.discharge}} containers">
      <i class="fa fa-arrow-left" aria-hidden="true"></i>
      <i class="fa fa-ship" aria-hidden="true"></i>
      {{ berthVisit.discharge }}
    </span>
  }
  @if (terminalVisit?.info?.expectedLoad || berthVisit.load) {
    <span class="d-none d-md-inline text-muted mx-3"
          title="Loading {{terminalVisit?.info?.expectedLoad ?? berthVisit.load}} containers">
      <i class="fa fa-arrow-right" aria-hidden="true"></i>
      <i class="fa fa-ship" aria-hidden="true"></i>
      {{ berthVisit.load }}
    </span>
  }
</ng-template>
